var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9816 30.4816C23.2557 30.4816 29.9631 23.7741 29.9631 15.5C29.9631 7.2259 23.2557 0.518402 14.9816 0.518402C6.70748 0.518402 0 7.2259 0 15.5C0 23.7741 6.70748 30.4816 14.9816 30.4816Z",
    fill: "#E8F7FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_3454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9816 30.4816C23.2557 30.4816 29.9631 23.7741 29.9631 15.5C29.9631 7.2259 23.2557 0.518402 14.9816 0.518402C6.70748 0.518402 0 7.2259 0 15.5C0 23.7741 6.70748 30.4816 14.9816 30.4816Z",
    fill: "#0067F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_3454)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43359 10.1606H12.0981V30.1472H8.43359V10.1606ZM19.7506 10.1606H23.4152V30.1472H19.7506V10.1606Z",
    fill: "#2948CE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1304 0.986045L31.8587 14.3609C31.9232 14.4194 31.9684 14.4961 31.9884 14.5809C32.0085 14.6656 32.0024 14.7544 31.9709 14.8356C31.9395 14.9169 31.8842 14.9866 31.8123 15.0358C31.7405 15.085 31.6554 15.1113 31.5683 15.1112H2.11376C2.02672 15.1112 1.94172 15.0848 1.86994 15.0356C1.79816 14.9864 1.74295 14.9166 1.71159 14.8354C1.68022 14.7542 1.67416 14.6654 1.69421 14.5807C1.71426 14.496 1.75947 14.4194 1.8239 14.3609L16.5512 0.986045C16.6305 0.914131 16.7337 0.874298 16.8408 0.874298C16.9478 0.874298 17.0511 0.914131 17.1304 0.986045Z",
    fill: "#2948CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.667a2baa018edf70fca852f20ccf687f.svg";
export { ForwardRef as ReactComponent };